// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23_3J","colBig":"styles_colBig__2MbYZ","colSmall":"styles_colSmall__1K_xm"};